/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";

function createMarkup(text) {
  return { __html: text };
}

function HelpText({ text, className }) {
  if (!text) {
    return null;
  }
  return (
    <span
      className={`help-block m-b-none text-neutral-500 ${className}`}
      dangerouslySetInnerHTML={createMarkup(text)}
    />
  );
}

HelpText.propTypes = {
  field: PropTypes.string,
};

export default HelpText;
